// These keywords whitelist document types to be shown in the pet page documents section but with different logic:

// keep only first (old) type of document
export const oldVersionKeywords = [
  'Versicherungsschein',
].map((item) =>
  item.toLowerCase().normalize('NFD')
);

// keep all versions of these documents (when tariff/coverage changes, show all versions)
export const allVersionsKeywords = [
  'Vertragsinformationen',
  'Beitragsanpassung',
  'Beitragsrechnung',
  'Mahnung',
  'Änderungsnachtrag',
  'Widerrufsbestätigung'
].map((item) => item.toLowerCase().normalize('NFD'));

// keep only last types docuemnts
export const latestVersionKeywords = [
  'Änderungs-Nachtrag',
  // 'Abbuchung',
  'Rücktritt',
  'Kündigung',
  'Kündigungsbestätigung',
  'Vertragsbeendigung',
].map((item) => item.toLowerCase().normalize('NFD'));

